// Note: changing this could affect tracking (https://notonthehighstreet.atlassian.net/browse/FFA-514?focusedCommentId=54133)
export const ICON_BUTTON__ICON_CLASS = 'icon_button__icon';
export const ICON_BUTTON__BUTTON_CLASS = 'icon_button__button';
